import React from 'react'

import DropdownDispositivos from './DropdownDispositivos'
import FilterOption from './FilterOption'

const filtrosParaDispositivos = {
  status: [
    { clickParam: { ULTIMA_CONEXAO: 'online' }, label: 'Online' },
    { clickParam: { ULTIMA_CONEXAO: 'ultima_conexao' }, label: 'Offline' },
    { clickParam: { ULTIMA_CONEXAO: 'estoque' }, label: 'Estoque' }
  ],
  semComunicar: [
    {
      clickParam: { SEM_COMUNICAR: 'sem_comunicacao_24h' },
      label: 'Nas últimas 24 horas'
    },
    {
      clickParam: { SEM_COMUNICAR: 'sem_comunicacao_24h_30d' },
      label: 'Entre 24 horas e 30 dias'
    },
    {
      clickParam: { SEM_COMUNICAR: 'sem_comunicacao_30d_60d' },
      label: 'Entre 30 a 60 dias'
    },
    {
      clickParam: { SEM_COMUNICAR: 'sem_comunicacao_60d' },
      label: 'Mais de 60 dias'
    },
    { clickParam: { ULTIMA_CONEXAO: 'estoque' }, label: 'Em estoque' }
  ]
}

export default function ListaMostrarEmDispositivos({ tipo, ...props }) {
  return (
    <li>
      <DropdownDispositivos {...props} />
      <ul
        id="menu-mostrar-em-dispositivos"
        className="drop-acoes-lista-submenu dropdown-desativado"
      >
        {filtrosParaDispositivos[tipo].map((item) => {
          return <FilterOption key={item.label} item={item} {...props} />
        })}
      </ul>
    </li>
  )
}
